import { getUserRiskInfo } from "@/api/common.module";

export default {
  // 获取用户风险等级并上传
  install(Vue, options) {
    Vue.prototype.$getUserRiskInfo = async function (activityKey, entry_type) {
      let res = await getUserRiskInfo(activityKey);
      if (res) {
        if (process.env.NODE_ENV === "production") {
          sensors.track("activity_user_risk_info", {
            activityName: activityKey,
            ProductName: "用户risk信息",
            referrer: document.referrer,
            activity_id: res.data.activity_id,
            activity_risk: !res.data.is_show,
            entry_type: entry_type,
            id: res.data.uid,
          });
        }
      }
    };
  },
};
